"use client";

import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Link } from "@/components/common/Link";
import { Loader } from "lucide-react";
export default function KontaktAVypocetZdarma() {
  return <section id="kontakt-a-výpočet-zdarma" className="dark bg-background text-foreground min-h-screen flex items-center transition-all duration-[var(--duration-slow)] opacity-100 translate-y-0">
      <div className="container mx-auto px-4 py-16">
        <div className="grid lg:grid-cols-2 gap-0 rounded-lg overflow-hidden shadow-strong">
          {}
          <div className="bg-secondary p-12 lg:p-16 flex flex-col justify-center relative overflow-hidden">
            <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/dark_textured_background.png)] bg-cover bg-center opacity-30"></div>
            <div className="relative z-10">
              <h2 className="font-display text-5xl lg:text-6xl text-primary mb-8 tracking-tight leading-tight">
                Kontakt a výpočet zdarma
              </h2>
              <div className="space-y-6">
                <div>
                  <p className="text-primary text-lg font-semibold mb-2">René Salva</p>
                  <p className="text-muted-foreground text-sm">Odborný konzultant</p>
                </div>
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="w-1 h-8 bg-primary rounded-full"></div>
                    <div>
                      <p className="text-xs text-muted-foreground uppercase tracking-wider mb-1">Telefon</p>
                      <Link to="tel:+420732438067" className="text-foreground hover:text-primary transition-colors duration-200">
                        +420 732 438 067
                      </Link>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-1 h-8 bg-primary rounded-full"></div>
                    <div>
                      <p className="text-xs text-muted-foreground uppercase tracking-wider mb-1">Email</p>
                      <Link to="mailto:cisteni.renovacestrech@gmail.com" className="text-foreground hover:text-primary transition-colors duration-200 break-all">
                        cisteni.renovacestrech@gmail.com
                      </Link>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-1 h-8 bg-primary rounded-full"></div>
                    <div>
                      <p className="text-xs text-muted-foreground uppercase tracking-wider mb-1">Adresa</p>
                      <p className="text-foreground">Chrudím</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <div className="w-1 h-8 bg-primary rounded-full"></div>
                    <div>
                      <p className="text-xs text-muted-foreground uppercase tracking-wider mb-1">Pracovní doba</p>
                      <p className="text-foreground">Po-Pá: 8:00-18:00</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="bg-accent p-12 lg:p-16 flex flex-col justify-center">
            <FormProvider className="w-full" formId="contact_calc_form_home" sectionName="kontakt-a-vypocet-zdarma" email="cisteni.renovacestrech@gmail.com" defaultValues={{
            name: "",
            email: "",
            phone: "",
            service_type: "",
            address: "",
            message: ""
          }} validationRules={{
            name: {
              required: true,
              minLength: 2,
              maxLength: 100
            },
            email: {
              required: true,
              pattern: "email"
            },
            phone: {
              required: true,
              pattern: "phone"
            },
            service_type: {
              required: true
            },
            address: {
              required: false
            },
            message: {
              required: false
            }
          }} submitText="Odeslat poptávku" successMessage="Děkujeme! Vaši poptávku jsme obdrželi a brzy se vám ozveme s nabídkou." errorMessage="Při odesílání formuláře došlo k chybě. Zkuste to prosím znovu.">
              <ContactCalcForm />
            </FormProvider>
          </div>
        </div>
      </div>
    </section>;
}
function ContactCalcForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="glass-effect p-8 text-center space-y-6">
        <div className="w-16 h-16 bg-primary/20 rounded-full flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        <p className="text-foreground text-lg">{successMessage}</p>
        <Button onClick={resetForm} variant="outline" className="mt-6">
          Odeslat další poptávku
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit}>
      <div className="space-y-6">
        <FormField control={control} name="name" rules={{
        required: "Jméno a příjmení je povinné",
        minLength: {
          value: 2,
          message: "Minimálně 2 znaky"
        },
        maxLength: {
          value: 100,
          message: "Maximálně 100 znaků"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground">Jméno a příjmení</FormLabel>
              <FormControl>
                <Input placeholder="Jan Novák" className="bg-secondary-dark border-b-2 border-t-0 border-l-0 border-r-0 border-muted rounded-none px-0 focus-visible:border-primary focus-visible:ring-0 transition-colors duration-200" {...field} />
              </FormControl>
              <p className="text-muted-foreground text-xs mt-1">Zadejte celé jméno, jak se vám bude ozývat.</p>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "E-mailová adresa je povinná",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Neplatná e-mailová adresa"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground">E-mailová adresa</FormLabel>
              <FormControl>
                <Input type="email" placeholder="jan.novak@example.com" className="bg-secondary-dark border-b-2 border-t-0 border-l-0 border-r-0 border-muted rounded-none px-0 focus-visible:border-primary focus-visible:ring-0 transition-colors duration-200" {...field} />
              </FormControl>
              <p className="text-muted-foreground text-xs mt-1">Pro zaslání nabídky a potvrzení kontaktu.</p>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        required: "Telefonní číslo je povinné",
        pattern: {
          value: /^(\+420)?[0-9\s]{9,}$/,
          message: "Neplatné telefonní číslo"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground">Telefonní číslo</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+420 123 456 789" className="bg-secondary-dark border-b-2 border-t-0 border-l-0 border-r-0 border-muted rounded-none px-0 focus-visible:border-primary focus-visible:ring-0 transition-colors duration-200" {...field} />
              </FormControl>
              <p className="text-muted-foreground text-xs mt-1">Telefon, na který vás můžeme kontaktovat.</p>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="service_type" rules={{
        required: "Typ služby je povinný"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground">Typ služby</FormLabel>
              <FormControl>
                <select className="bg-secondary-dark border-b-2 border-t-0 border-l-0 border-r-0 border-muted rounded-none px-0 w-full h-9 text-base text-foreground focus-visible:border-primary focus-visible:ring-0 focus-visible:outline-none transition-colors duration-200" {...field}>
                  <option value="">Vyberte požadovanou službu</option>
                  <option value="Fotovoltaika">Fotovoltaika</option>
                  <option value="Vysokotlaké čištění střech">Vysokotlaké čištění střech</option>
                  <option value="Technologická impregnace">Technologická impregnace</option>
                  <option value="Čištění fasád">Čištění fasád</option>
                  <option value="Čištění okapů">Čištění okapů</option>
                  <option value="Čištění chodníků">Čištění chodníků</option>
                </select>
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="address" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground">Adresa nemovitosti (volitelné)</FormLabel>
              <FormControl>
                <Input placeholder="Ulice 123, 110 00 Praha" className="bg-secondary-dark border-b-2 border-t-0 border-l-0 border-r-0 border-muted rounded-none px-0 focus-visible:border-primary focus-visible:ring-0 transition-colors duration-200" {...field} />
              </FormControl>
              <p className="text-muted-foreground text-xs mt-1">Uveďte adresu, kde má být služba provedena (pro přesnější kalkulaci).</p>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="message" render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground">Zpráva / Specifikace požadavku (volitelné)</FormLabel>
              <FormControl>
                <Textarea placeholder="Popište vaše požadavky, rozměry, případné dotazy..." className="bg-secondary-dark border-b-2 border-t-0 border-l-0 border-r-0 border-muted rounded-none px-0 focus-visible:border-primary focus-visible:ring-0 transition-colors duration-200 min-h-24" {...field} />
              </FormControl>
              <p className="text-muted-foreground text-xs mt-1">Čím podrobněji popíšete projekt, tím přesnější bude nabídka.</p>
              <FormMessage />
            </FormItem>} />

        {submitError && <div className="glass-effect p-4 border border-red-500/30">
            <p className="text-red-500 text-sm">{submitError}</p>
          </div>}

        <Button type="submit" disabled={isSubmitting} className="btn-primary w-full mt-8 h-12 text-base uppercase tracking-widest">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-5" />
              Odesílám...
            </> : "Odeslat poptávku"}
        </Button>
      </div>
    </Form>;
}